module.exports = __webpack_public_path__ + "static/media/png-icon.c573bc0f.svg";